import React from 'react';
import {
  Navigate,
  Outlet,
  useParams,
} from 'react-router-dom';
import { useExtensiveAttributeDefinitionReadFacade } from 'redux/extensive-attribute-definition-read/extensive-attribute-definition-read.facade';
import {
  CommonManagementFlag, ExtensiveAttributeModelValueEditAllowFlagEnum, ExtensiveAttributeValueType, AvailableFlag,
} from 'types/entity';

export function FpAdminExtensiveAttributeValueGuard() {
  const { extensiveAttributeDefinitions } = useExtensiveAttributeDefinitionReadFacade();

  const { extensive_attribute_definition_id } = useParams<{extensive_attribute_definition_id: string}>();
  const model = extensiveAttributeDefinitions
    .find((attr) => attr.extensive_attribute_definition_id === extensive_attribute_definition_id);

  const isSelectType: boolean = model?.value_type === ExtensiveAttributeValueType.SingleSelect || model?.value_type === ExtensiveAttributeValueType.MultiSelect;
  const available: boolean = model?.available_flag === AvailableFlag.Available;
  // 標準拡張属性の場合、編集が許可されていればtrue。ユーザー拡張属性の場合は無条件でtrue
  const editableValues: boolean = model?.common_management_flag === CommonManagementFlag.Common
    ? model.value_edit_allow_flag === ExtensiveAttributeModelValueEditAllowFlagEnum.Allow
    : true;

  const editable = (isSelectType && available && editableValues);

  return (
    <>
      { editable === true
        ? <Outlet />
        : <Navigate to="/admin/extended_attribute" replace />}
    </>
  );
}
